<template>
  <div class="chapter-directory-wrapper">
    <!-- 学科 -->
    <div class="subject-list-box">
      <div
        :class="{
          'subject-item': true,
          'subject-item-selected': item.subjectId === lastSelect.subjectId
        }"
        v-for="item in subjectList"
        :key="item.subjectId"
        @click="_subjectChange(item)"
      >{{item.subjectName}}</div>
    </div>
    <!-- 年级册别 -->
    <el-select
      v-model="lastSelect.volumeId"
      placeholder="请选择年级"
      :disabled="!isLogin"
      id="volumeSelect"
      :class="{
        'volume-select': true,
        'selec-readonly': !isLogin
      }"
      popper-class="volume-select-popper"
      @change="_volumeChange"
      @click.native.stop="!isLogin && _volumeClick()"
      >
      <el-option
        v-for="item in volumeList"
        :key="item.volumeId"
        :label="item.volumeName"
        :value="item.volumeId"
      ></el-option>
    </el-select>
    <!-- 章节 -->
    <div 
      class="chapter-tree-box"
      v-loading="listLoading"
      element-loading-text="数据正在跑步前进中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="grba(255, 255, 255, 0.5)"
      >
      <el-tree 
        class="chapter-tree"
        ref="chapterTree"
        id="chapterTree"
        :data="chapterData" 
        :props="defaultProps" 
        :default-expanded-keys="defaultExpanedKeys"
        node-key="chapterId"
        :expand-on-click-node="false"
        :highlight-current="true"
        :empty-text="listLoading ? '' : '暂无数据'"
        @node-click="_chapterNodeClick"
        @node-expand="_nodeExpend"
        ></el-tree>
    </div>
  </div>
</template>
<script>
import store from 'store';
import { mapState } from "vuex";
import { localStorageUtil, debounce, preventRepeatMessage } from "utils/util";
import { reqGetChapter, reqUpdateUserSelected } from 'api/synchronous-courses';
import { GetDefaultSubjects } from 'api/common';
export default {
  name: "ChapterDirectory",
  data() {
    return {
      listLoading: true,
      isSelect: 0,
      subjectList: [
        {
          subjectId: 2,
          subjectName: "语文"
        },
        {
          subjectId: 1,
          subjectName: "数学"
        },
        {
          subjectId: 4,
          subjectName: "英语"
        },
        {
          subjectId: 5,
          subjectName: "历史"
        },
        {
          subjectId: 6,
          subjectName: "化学"
        },
        {
          subjectId: 7,
          subjectName: "物理"
        },
        {
          subjectId: 8,
          subjectName: "地理"
        },
        {
          subjectId: 9,
          subjectName: "生物"
        },
        {
          subjectId: 10,
          subjectName: "道德与法治"
        }
      ],
      volumeList: [
        {
          volumeId: 14,
          volumeName: "七年级上册"
        },
        {
          volumeId: 15,
          volumeName: "七年级下册"
        },
        {
          volumeId: 16,
          volumeName: "八年级上册"
        },
        {
          volumeId: 17,
          volumeName: "八年级下册"
        },
        {
          volumeId: 18,
          volumeName: "九年级上册"
        },
        {
          volumeId: 19,
          volumeName: "九年级下册"
        }
      ],
      chapterData: [],
      defaultProps: {
        children: "children",
        label: "chapterTitle"
      },
      defaultExpanedKeys: [],
      lastSelect: {},
      subjects: null,

    };
  },
  computed: {
    ...mapState(["accountInfo", "isLogin"])
  },
  watch: {
    lastSelect: {
      deep: true,
      handler(val) {
        if(val) {
          let _accountInfo = localStorageUtil.getItem('accountInfo');
          if(_accountInfo && _accountInfo.phone) {
            localStorageUtil.setItem(`${_accountInfo.phone}_lastSelect`, val);
          }
          this._updateUserSelected();
        }
      }
    },
    accountInfo(val) {
      if(val) {

      }
    }
  },
  methods: {
    _volumeClick() {
      this.$emit('handleLimit');
      console.log('not login', this.isLogin);
    },
    /**
     * 目录更新
     * **/
    _updateUserSelected() {
      let obj = {
        subjectId: this.lastSelect.subjectId,
        editionId: this.lastSelect.editionId,
        volumeId: this.lastSelect.volumeId,
      };
      if(this.lastSelect.chapterOneId) {
        obj.chapterOneId = this.lastSelect.chapterOneId;
        if(this.lastSelect.chapterTwoId) {
          obj.chapterTwoId = this.lastSelect.chapterTwoId;
          if(this.lastSelect.chapterThreeId) {
            obj.chapterThreeId = this.lastSelect.chapterThreeId;
          }
        }
      }
      return reqUpdateUserSelected(obj).then(res => {
        if(res.code === 0) {
        }else {
          console.log('章节目录更新失败', res);
        }
      }).catch(err => {
        console.log('章节目录更新失败', err);
      });
    },
    /**
     * 学科选择
     * **/
    _subjectChange(item) {
      if(!this.isLogin) {
        this.$emit('handleLimit');
        console.log('not login', this.isLogin);
        return;
      }
      if(this.lastSelect.subjectId == item.subjectId) {
        return;
      }
      this.lastSelect.subjectId = item.subjectId;
      this.lastSelect.subjectName = item.subjectName;
      this._pageInit('subjectChagne', this.lastSelect);
    },
    /**
     * 年级选择
     * **/
    _volumeChange() {
      let _find = this.volumeList.find(ele => ele.volumeId == this.lastSelect.volumeId);
      if(_find) {
        let _last = Object.assign({}, this.lastSelect);
        _last.volumeName = _find.volumeName;
        _last[_last.subjectId][1] = {
          volumeId: _find.volumeId,
          volumeName: _find.volumeName
        };
        _last[_last.subjectId] = _last[_last.subjectId].splice(0, 2);
        _last.chapterOneId = null;
        _last.chapterTwoId = null;
        _last.chapterThreeId = null;
        this.lastSelect = Object.assign({}, _last);
        this.$nextTick(() => {
          $('#volumeSelect').val(this.lastSelect.editionName + '/' + this.lastSelect.volumeName)
        });
      }
      this._getChapter();
    },
    /**
     * 章节选择
     * **/
    _chapterNodeClick(data, node) {
      if(data !== 'init' && !this.isLogin) {
        this.$emit('handleLimit');
        console.log('not login', this.isLogin);
        this.$refs.chapterTree.setCurrentKey(null);
        // this.$refs.chapterTree.setCurrentKey(this.lastSelect.chapterThreeId ? this.lastSelect.chapterThreeId : (this.lastSelect.chapterTwoId ? this.lastSelect.chapterTwoId : this.lastSelect.chapterOneId));
        return;
      }
      let _last = Object.assign({}, this.lastSelect);
      if(data === 'init') {
        _last.chapterOneId = 0;
        _last.chapterTwoId = null;
        _last.chapterThreeId = null;
      }else if(node.level === 1) {
        _last.chapterOneId = node.data.chapterId;
        _last.chapterTwoId = null;
        _last.chapterThreeId = null;
      } else if(node.level === 2){
        _last.chapterOneId = node.parent.data.chapterId;
        _last.chapterTwoId = node.data.chapterId;
        _last.chapterThreeId = null;
      } else if(node.level === 3){
        _last.chapterOneId = node.parent.parent.data.chapterId;
        _last.chapterTwoId = node.parent.data.chapterId;
        _last.chapterThreeId = node.data.chapterId;
      }
      // _last[_last.subjectId]
      if(_last[_last.subjectId] && _last[_last.subjectId].length >= 2) {
        _last[_last.subjectId][2] = {
          chapterOneId: _last.chapterOneId,
          chapterTwoId: _last.chapterTwoId,
          chapterThreeId: _last.chapterThreeId,
        }
      }
      this.lastSelect = Object.assign({}, _last);
      this.$emit('handleChange', this.lastSelect, 'chapter');
    },
    /**
     * 展开折叠时设置title
     * **/
    _nodeExpend(data, node, item) {
      this.$nextTick(() => {
        let $el = $(item.$el).find('.el-tree-node__children .el-tree-node__label');
        this._setTreeCss($el);
      });
    },
    /**
     * 获取章节
     * **/
    _getChapter(type) {
      if(type !== 'init') {
        // this.lastSelect.chapterOneId = null;
        // this.lastSelect.chapterTwoId = null;
        // this.lastSelect.chapterThreeId = null;
      }
      let obj = {
        subjectId: Number(this.lastSelect.subjectId),
        editionId: Number(this.lastSelect.editionId),
        volumeId: Number(this.lastSelect.volumeId),
      };
      this.listLoading = true;
      return reqGetChapter(obj).then(res => {
        this.listLoading = false;
        if(res.code === 0) {
          let _data = [...res.data];
          _data.unshift({
            chapterId: 0,
            chapterTitle: "全部章节"
          });
          this.chapterData = _data;
          this._defaultExpansion();
          this.$emit('handleChange', this.lastSelect, 'chapterInit');
          this.$nextTick(() => {
            this._setTreeCss($('#chapterTree .el-tree-node__label'));
            if(!this.isLogin) {
              this._setTreeDis();
            }
          });
        }else if(res.code === 14001) {
          store.commit('LOGOUT', null);
          preventRepeatMessage();
          setTimeout(() => {
            this.$router.replace({
              path: '/home-page',
              query: {
                redirect: this.$route.path,
                reload: true
              }
            });
          }, 500);
        }else {
          this.$message({
            type: 'error',
            message: '章节目录获取失败',
            duration: 2000
          });
          this.$emit('handleChange', false);
          console.log(res);
        }
      }).catch(err => {
        this.listLoading = false;
        this.$emit('handleChange', false);
        console.log('章节目录获取失败', err);
      });
    },
    /**
     * 章节回选
     * **/
    _defaultExpansion() {
      let _arr = [];
      if(this.lastSelect.chapterThreeId) {
        _arr = [this.lastSelect.chapterThreeId];
      } else if(this.lastSelect.chapterTwoId) {
        _arr = [this.lastSelect.chapterTwoId];
      } else if(this.lastSelect.chapterOneId) {
        _arr = [this.lastSelect.chapterOneId];
      }else if(this.chapterData.length && this.chapterData[0].chapterId) {
        _arr.push(this.chapterData[0].chapterId);
        if(this.chapterData[0].children && this.chapterData[0].children.length) {
          _arr.push(this.chapterData[0].children[0].chapterId);
          if(this.chapterData[0].children[0].children && this.chapterData[0].children[0].children.length) {
            _arr.push(this.chapterData[0].children[0].children[0].chapterId);
          }
        }
      }
      this.defaultExpanedKeys = _arr;
      this.$nextTick(() => {
        if(this.lastSelect.chapterOneId) {
          this.$refs.chapterTree.setCurrentKey(this.lastSelect.chapterThreeId ? this.lastSelect.chapterThreeId : (this.lastSelect.chapterTwoId ? this.lastSelect.chapterTwoId : this.lastSelect.chapterOneId));
          let _getCurrentKey = this.$refs.chapterTree.getCurrentKey()
          if(!_getCurrentKey) {
            this._chapterNodeClick('init');
            this.$refs.chapterTree.setCurrentKey(0);
          } 
        }else if(this.isLogin) {
          this.$refs.chapterTree.setCurrentKey(0); 
        }
      });
    },

    /**
     * 初始化数据处理
     * **/
    _pageInit(type, select = {}) {
      let _select = type === 'init' ? {} : select;
      let _accountInfo = localStorageUtil.getItem('accountInfo');
      if(type === 'init' && _accountInfo && _accountInfo.phone) {
        if(_accountInfo && _accountInfo.phone) { // 已登录
          let _accountLast = localStorageUtil.getItem(`${_accountInfo.phone}_lastSelect`);
          if(_accountLast) {
            _select = _accountLast;
          }else {
            _select = localStorageUtil.getItem('lastSelect');
          }
        }else { // 未登录
          _select = localStorageUtil.getItem('lastSelect');
        }
        
      }
      if(!_select.subjectId) {
        _select.subjectId = 2;
        _select.subjectName = '语文';
      }
      if(_select[_select.subjectId] && 
        _select[_select.subjectId].length >= 2 && 
        _select[_select.subjectId][0].editionId && 
        _select[_select.subjectId][1].volumeId) {
        _select.editionId = Number(_select[_select.subjectId][0].editionId);
        _select.editionName = _select[_select.subjectId][0].editionName;
        _select.volumeId = Number(_select[_select.subjectId][1].volumeId);
        _select.volumeName = _select[_select.subjectId][1].volumeName;
        if( _select[_select.subjectId][2]) {
          _select.chapterOneId = _select[_select.subjectId][2].chapterOneId;
          _select.chapterTwoId = _select[_select.subjectId][2].chapterTwoId;
          _select.chapterThreeId = _select[_select.subjectId][2].chapterThreeId;
        }else {
          _select.chapterOneId = null;
          _select.chapterTwoId = null;
          _select.chapterThreeId = null;
        }
      }else {
        _select.editionId = null;
        _select.editionName = null;
        _select.volumeId = null;
        _select.volumeName = null;
        _select.chapterOneId = null;
        _select.chapterTwoId = null;
        _select.chapterThreeId = null;
        _select[_select.subjectId] = [];
      }
      if(!_select.editionId) {
        _select.editionId = this.subjects[_select.subjectId].editionId;
        _select.editionName = this.subjects[_select.subjectId].editionName;
      }
      if(this.subjects[_select.subjectId].editions[_select.editionId]) {
        this.volumeList = this.subjects[_select.subjectId].editions[_select.editionId].volumes;
        // this.volumeList.map(ele => ele.volumeName = _select.editionName + '/' + ele.volumeName);
      }
      if(!_select.volumeId) {
        if(_accountInfo && _accountInfo.phone && _select.subjectId === 2) {
          switch (_accountInfo.gradeId) {
            case 7:
              _select.volumeId = this.volumeList[0].volumeId;
              _select.volumeName = this.volumeList[0].volumeName;
              break;
            case 8:
              _select.volumeId = this.volumeList[2].volumeId;
              _select.volumeName = this.volumeList[2].volumeName;
              break;
            case 9:
              _select.volumeId = this.volumeList[4].volumeId;
              _select.volumeName = this.volumeList[4].volumeName;
              break;
            default:
              _select.volumeId = this.volumeList[0].volumeId;
              _select.volumeName = this.volumeList[0].volumeName;
              break;
          }
        }else {
          _select.volumeId = this.volumeList[0].volumeId;
          _select.volumeName = this.volumeList[0].volumeName;
        }
        
      }
      _select[_select.subjectId][0] = {
        editionId: _select.editionId,
        editionName: _select.editionName
      };
      _select[_select.subjectId][1] = {
        volumeId: _select.volumeId,
        volumeName: _select.volumeName
      };

      if(!_select.chapterOneId) {
        _select.chapterOneId = null;
        _select.chapterTwoId = null;
        _select.chapterThreeId = null;
      } else if(!_select.chapterTwoId) {
        _select.chapterTwoId = null;
        _select.chapterThreeId = null;
      } else if(!_select.chapterThreeId) {
        _select.chapterThreeId = null;
      }
      this.lastSelect = _select;
      this.$nextTick(() => {
        $('#volumeSelect').val(this.lastSelect.editionName + '/' + this.lastSelect.volumeName)
      });
      this._getChapter(type);
    },

    /**
     * el-tree title处理
     * **/
    _setTreeCss(ele) {
      ele.each(function() {
        let _w = $(this).width();
        let $c = $(this).clone().css({display: 'inline', width: 'auto', visibility: 'hidden'}).appendTo('body');
        if( $c.width() > _w) {
          $(this).attr({'title': $c.text()});
        }else {
          $(this).attr({'title': ''});
        }
        $c.remove();
      });
    },

    /**
     * el-tree 禁用展开折叠
     * **/
    _setTreeDis(ele) {
      let _this = this;
      $('#chapterTree .el-tree-node__expand-icon').each(function() {
        let _display = $(this).css('display');
        if(_display !== 'none') {
          let $c = $(this).clone().removeClass().addClass('expand-icon-dis');
          $c.appendTo($(this).parent());
          $c.on('click', function(event) {
            if(!_this.isLogin) {
              _this.$emit('handleLimit');
              console.log('not login', _this.isLogin);
              event.stopPropagation();
              event.preventDefault();
              return false;
            }
          });
          // console.log($(this).parent());
        }
      });
    }
  },
  async created() {
    if(localStorageUtil.getItem('subjects')) {
      this.subjects = localStorageUtil.getItem('subjects');
      this._pageInit('init');
    }else {
      let _data = await GetDefaultSubjects();
      this.subjects = _data;
      this._pageInit('init');
    }
  }
};
</script>
<style lang="less">
@color-main: #03B2B2;
.chapter-directory-wrapper {
  width: 270px;
  margin-right: 46px;
  background: #D3F0F0;
  border-radius: 6px;
  display: inline-block;
  vertical-align: top;
  // margin-bottom: 20px;
  min-height: calc(100vh - 110px - 70px);
  .subject-list-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 20px 10px 10px;
    .subject-item {
      width: 70px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      border-radius: 4px;
      background: #fff;
      &:nth-of-type(9) {
        font-size: 12px;
        line-height: 28px;
      }
      margin-bottom: 12px;
      color: #717171;
      cursor: pointer;
      &.subject-item-selected {
        color: #fff;
        background: @color-main;
      }
      &:not(.subject-item-selected):hover {
        color: #fff;
        background: #A7D9D9;
      }
    }
  }
  .volume-select {
    width: 100%;
    .el-input {
      .el-input__inner {
        border: 0px solid #56C3C3;
        background: #56C3C3;
        border-radius: 0;
        color: #fff;
        padding-left: 20px;
        font-weight: bold;
        &::placeholder {
          color: #fff !important; 
        }
      }
      .el-input__suffix {
        right: 14px;
        .el-icon-arrow-up:before {
          font-family: "iconfont" !important;
          content: "\e752";
        }
        .el-select__caret {
          color: #fff;
          transform: rotateZ(0deg) !important;
          &.is-reverse {
            transform: rotateZ(-180deg) !important;
          }
        }
      }
    }
    &.selec-readonly {
      .is-disabled .el-input__inner, .is-disabled .el-input__icon {
        cursor: pointer !important;
      }
    }
  }
  .chapter-tree-box {
    height: calc(100vh - 110px - 70px - 154px - 40px - 10px);
    overflow-y: auto;
    .chapter-tree.el-tree {
      background: transparent;
      .el-tree__empty-block {
        margin-top: 200px;
      }
      .el-tree-node {
        &.is-focusable {
          .el-tree-node__content {
            background: transparent !important;
           
          }
        }
        .el-tree-node__content {
          height: 36px;
          line-height: 36px;
          position: relative;
          &:hover {
            background:#beebeb !important;
          }
          .el-tree-node__label {
            display: inline-block;
            padding-right: 10px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .el-tree-node__expand-icon.is-leaf {
            color: transparent;
            cursor: default;
            &:first-of-type {
              display: none;
            }
          }
          .el-tree-node__expand-icon.is-leaf:first-of-type + .el-tree-node__label {
            padding-left: 20px;
          }
          .expand-icon-dis {
            display: inline-block;
            width: 40px;
            height: 27px;
            background: transparent;
            position: absolute;
            top: 6px;
            left: 0;
            z-index: 1;
          }
          .el-tree-node__expand-icon:not(.is-leaf) {
            // position: relative;
            // &:after {
            //   content: '';
            //   display: inline-block;
            //   width: 100%;
            //   height: 100%;
            //   background: #999;
            //   position: absolute;
            //   left: 0;
            //   top: 0;
            //   z-index: 10;
            // }
          }
          .el-icon-caret-right {
            font-size: 14px;
            color: #717171;
            padding-top: 7px;
            &:before {
              font-family: 'iconfont' !important;
              content: '\e6aa';
            }
          }
          .el-tree-node__expand-icon.expanded{
            transform: rotate(0deg) !important;
            &.el-icon-caret-right:before {
              font-family: 'iconfont' !important;
              content: '\e6a7';
            }
          }
        }
        
        >.el-tree-node__content {
          .el-tree-node__expand-icon {
            padding-left: 20px;
          }
          .el-tree-node__label {
            color: #4F4F4F;
            font-weight: bold;
            // padding-left: 4px;
          }
        }
        >.el-tree-node__children {
          .el-tree-node {
            .el-tree-node__content {
              .el-tree-node__expand-icon {
                padding-left: 20px;
              }
              .is-leaf.el-tree-node__expand-icon {
                display: none;
              }
              .is-leaf.el-tree-node__expand-icon + .el-tree-node__label {
                margin-left: 20px;
              }
              .el-tree-node__label {
                color: #717171;
                // padding-left: 2px;
              }
            }
            .el-tree-node__children {
              .el-tree-node {
                .el-tree-node__content {
                  padding-left: 52px !important;
                  .el-tree-node__expand-icon {
                    display: none;
                  }
                  .is-leaf.el-tree-node__expand-icon + .el-tree-node__label {
                    margin-left: 0;
                  }
                  .el-tree-node__label {
                    font-weight: normal;
                    color: #666;
                  }
                }
              }
            }
          }
        }
      }
      
      &.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
        background-color: #B6E3E3 !important;
        .el-tree-node__label {
          color: @color-main !important;
        }
      }
    }
  }
}
.volume-select-popper {
  .popper__arrow {
    left: 236px !important;
  }
  .el-select-dropdown__item {
    padding-left: 46px !important;
  }
}
</style>